import styled from 'styled-components';
import { focusRing, userSelectNone } from '../../styles/mixins';

export const ShowMoreSeparator = styled.div`
  width: 100%;
  clear: both;
`;

export const ShowMoreStyled = styled.div`
  display: none;
  position: relative;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 30px;
  margin: 0 0 15px;
  width: 100%;
  height: 51px;
  background: #ffffff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  border-radius: 9px;
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  font-style: normal;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: 19px;
  cursor: pointer;
  clear: both;
  transition: all 0.3s ease-in-out;

  ${userSelectNone};

  &:hover {
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
  }

  &:focus-visible {
    ${focusRing}
  }

  @media only screen and (min-width: 1024px) {
    margin: 0 auto 15px;
  }

  &.openx-ui-discover {
    display: flex;
  }
`;

export const ShowMoreSpinner = styled.div`
  top: 50%;
  left: 50%;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff;
  -webkit-animation: spin 1s infinite linear 0.1s;
  -moz-animation: spin 1s infinite linear 0.1s;
  animation: spin 1s infinite linear 0.1s;
  border-top: 3px solid #e5e9ed;
  border-right: 3px solid #e5e9ed;
  border-bottom: 3px solid #e5e9ed;
  border-left: 3px solid ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  display: none;
`;
